import {
    CORS_MODE_NAME,
    FetchRequestOptions,
    fetchService,
    POST_METHOD_NAME,
} from 'owa-data-provider-info-fetcher';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { CreateSharingLinkFromFileProviderResult } from './CreateSharingLinkFromFileProviderResult';
import { SharingLinkTypeView, SharingLinkTypeEdit } from '../utils/constants';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';

export async function createSharingLinkFromOneDriveConsumer(
    requestUrl: string,
    permissionLevel: AttachmentPermissionLevel,
    dataPointName: string
): Promise<CreateSharingLinkFromFileProviderResult> {
    const bodyContent: string = getBody(permissionLevel);
    const requestOptions: FetchRequestOptions = {
        method: POST_METHOD_NAME,
        mode: CORS_MODE_NAME,
        body: bodyContent,
        datapointNamePrefix: dataPointName,
    };

    const responseText: string = await fetchService(
        AttachmentDataProviderType.OneDriveConsumer,
        requestUrl,
        null,
        requestOptions
    );
    return JSON.parse(responseText);
}

function createRequestBody(permissionLevel: AttachmentPermissionLevel) {
    return {
        type:
            permissionLevel === AttachmentPermissionLevel.Edit
                ? SharingLinkTypeEdit
                : SharingLinkTypeView,
    };
}

function getBody(permissionLevel: AttachmentPermissionLevel): string {
    return JSON.stringify(createRequestBody(permissionLevel));
}
